import Button from 'src/components/button/Button';
import styled from 'src/lib/styles/css';

//#region [Props]
type TryAgainProps = {
	numCorrect: number;
	newQuiz: () => void;
};
//#endregion

//#region [Component]
export default function TryAgain({ numCorrect, newQuiz }: TryAgainProps) {
	return <div>
		<STryAgainButton text="Start ny quiz" onClick={newQuiz} />
	</div>;
}
//#endregion

//#region [Styles]
const STryAgainButton = styled(Button)`
	max-width: 400px;
	margin-left: auto;
	margin-right: auto;
	cursor: pointer;
    font-size: 20px;
    width: 100%;

	background: #812de2;
	font-weight: bold;
`;
//#endregion